<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchTypeOptions"
              v-model="queryData.announcementSearchCond"
              codeId="COD_NOTICOBJ_SRCH_DIV"
              :defaultOption="'all'"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @click="onClickSearch"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-select-box
              v-model="queryData.boardCategoryItemId"
              placeholder="selectbox"
              :option-list="categoryOptions"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="section-board">
        <ul>
          <li
            v-for="(item, index) in localdata0"
            :key="item.postUID"
          >
            <a href="#">
              <div class="tit-wrap">
                <strong class="tit"> {{ item.annNoticeObjTitle }}</strong>
                <div class="tit-right">
                  <span class="category"> {{ item.bbsCategoryItemNm }} </span>
                  <span class="date"> {{ item.firstRegistrationDTM }} </span>
                  <span class="name"> {{ item.registrantName }} </span>
                  <span class="view"> {{ item.annNoticeObjSearchedCount }} </span>
                </div>
              </div>
              <span class="tree-ellipsis">
                {{ decodeHtml(item.annNoticeObjContent) }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM'];
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'PGE_CLB_00029',
  extends: BasePage,
  data() {
    return {
      queryData: {
        announcementSearchCond: '',
        searchText: '',
        boardCategoryItemId: { label: this.$t('MSG_TXT_ALL'), key: '' },
        bbsId: 'BBS_NOTICE',
      },
      rangeDate: {
        from: '',
        to: '',
      },
      localdata0: [],
      categoryOptions: [],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'rowNumber',
      type: 'string',
      map: 'rowNumber',
    }, {
      name: 'bbsCategoryItemNm',
      type: 'string',
      map: 'bbsCategoryItemNm',
    }, {
      name: 'annNoticeObjTitle',
      type: 'object',
      map: 'annNoticeObjTitle',
    }, {
      name: 'attchDocId',
      type: 'object',
      map: 'attchDocId',
    }, {
      name: 'registrantName',
      type: 'string',
      map: 'registrantName',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }, {
      name: 'annNoticeObjSearchedCount',
      type: 'string',
      map: 'annNoticeObjSearchedCount',
    }, {
      name: 'postUID',
      type: 'string',
      map: 'postUID',
    }, {
      name: 'newYN',
      type: 'string',
      map: 'newYN',
    }, {
      name: 'atthDocId',
      type: 'object',
      map: 'atthDocId',
    }, {
      name: 'urgnYN',
      type: 'string',
      map: 'urgnYN',
    },
    {
      name: 'annYN',
      type: 'string',
      map: 'annYN',
    }, {
      name: 'annNoticeObjCount',
      type: 'object',
      map: 'annNoticeObjCount',
    }],
  }],
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.onLoadCategoryItems();
    },
    onLoadCategoryItems() {
      const pathParam = {
        'bulletin-board-id': this.queryData.bbsId,
      };
      http.request(this.contextPageId, 'DTS_CLB_00050', {
        path: pathParam,
      }).then(res => {
        if (res.data) {
          const optionList = res.data;
          let i;
          for (i = 0; i < optionList.length; i++) {
            optionList[i].label = optionList[i].bbsCatgItemNm;
            optionList[i].key = optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemNm;
            this.categoryOptions = optionList;
          }
          this.categoryOptions.unshift({ key: '', label: this.$t('MSG_TXT_ALL') });
        }
      });
    },
    decodeHtml(html) {
      const txt = document.createElement('span');
      txt.innerHTML = html;
      return txt.innerText;
    },
    onClickReset() {
      this.$refs.searchTypeOptions.reset();
      this.queryData.searchText = '';
      this.queryData.boardCategoryItemId = { label: this.$t('MSG_TXT_ALL'), key: '' };
      this.rangeDate = { from: '', to: '' };
    },
    onClickSearch() {
      const searchCond = this.queryData.announcementSearchCond;
      const dataParams = {
        announcementSearchCond: this.queryData.announcementSearchCond,
        announcementTitle: (searchCond === 'ALL' || searchCond === 'T') ? this.queryData.searchText : '',
        announcementRegistUsr: (searchCond === 'ALL' || searchCond === 'R') ? this.queryData.searchText : '',
        registStartDt: utils.dateformatToServer(this.rangeDate.from),
        registEndDt: utils.dateformatToServer(this.rangeDate.to).substr(0, 8).concat('235959'),
        boardCategoryItemId: this.queryData.boardCategoryItemId.key,
        bbsId: this.queryData.bbsId,
      };
      http.request(this.contextPageId, 'DTS_CLB_00001', {
        query: dataParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, 'firstRegistrationDTM');
        this.localdata0 = [];
        utils.forEach(res.data, items => {
          this.localdata0.push({
            postUID: items.postUID,
            annNoticeObjTitle: items.annNoticeObjTitle,
            annNoticeObjSearchedCount: items.annNoticeObjSearchedCount,
            annNoticeObjContent: items.annNoticeObjContent,
            firstRegistrationDTM: items.firstRegistrationDTM,
            registrantName: items.registrantName,
            bbsCategoryItemNm: items.bbsCategoryItemNm,
          });
        });
      });
      return true;
    },
  },
};
</script>
<style scoped>

</style>
